import { render, staticRenderFns } from "./footer-landing.vue?vue&type=template&id=58210cd7&scoped=true"
import script from "./footer-landing.vue?vue&type=script&lang=js"
export * from "./footer-landing.vue?vue&type=script&lang=js"
import style0 from "./footer-landing.vue?vue&type=style&index=0&id=58210cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58210cd7",
  null
  
)

export default component.exports